<template>
  <div class="not-found-outer">
    <header-section
      title="We're sorry..."
      :needs-jump-button="false"
      :needs-nav-buttons="false"
    />
    <div class="not-found-container container">
      <div class="ns-rte">
        <p>We cannot find the page <span class="unknown-url">{{ getPath() }}</span>, that you are trying to access. As a result of recent changes to our site, it may have moved or been removed.</p>
        <p>
          To find the content you are looking for, try searching by topic or <router-link :to="{ path: '/contact-us' }">
            contact us
          </router-link>.
        </p>
        <p>
          Go to the <router-link :to="{ path: '/'}">
            homepage
          </router-link>.
        </p>
        <p>Error 404</p>
      </div>
    </div>
    <hr class="home-row">
  </div>
</template>

<script>
import Header from '_components_/SectionComponents/Header';
export default {
	name: 'CustomNotFound',
	components: {
		'header-section': Header
	},
	beforeRouteEnter(to, from, next) {
		const path = window.location.href;
		next(vm => {
			vm.previousPath = path;
		});
	},
	data() {
		return {
			previousPath: ''
		};
	},
	methods: {
		getPath() {
			return this.previousPath || '';
		}
	}
};
</script>

<style scoped>
.unknown-url {
	font-weight: bold;
}
</style>
